import React, { Component, Fragment } from "react";
import productImg from "../../assets/images/no-product-image.png";
import leftArrowImage from "../../assets/images/left-arrow.png"
import {
  UtilityService,
  StyleServices,
  DevelopmentServices
} from "../../services";

//components
import Loading from "../../components/Common/Loading";
import StyleInfo from "../../components/CreateIBComponents/StyleInfo/StyleInfo";
import UploadSection from "../../components/CreateIBComponents/uploadSectionOrder/UploadSection";
import FileUploadButton from "../../components/FileUploadButton/FileUploadButton";
import Field from "../../components/Common/Field/Field";

class CreateIB extends Component {
  state = {
    uploadedFiles: [],
    //style
    styleInfo: {},
    additionalStyleInformation: "",
    styleId: "",
    referenceid: "",

    // order objects
    order: {},
    orderFileUpload: [],
    data: [{}],
    //order upload fileTypes
    categories: [
      "Order Confirmation - Booking Form",
      "Buyer CP",
      "Price Confirmation Email",
      "SCS/NPS/OCS",
      "Testing Docs",
      "Supplier Details",
      "Others",
      "CAD Marker"
    ],

    //garmentprocess
    garmentProcess: {},
    //fabric
    fabric: {},
    //trims
    trims: [{}],
    trimAdditionalInfo: "",
    //embroidery
    embroiedry: {
      backing: false
    },
    backingData: {},
    emblishmentDetails: {
      bitAttaching: false
    },
    embroiedryLeftValue: [
      "Bit Attaching",
      "Cutting",
      "Embroidery",
      "Recut",
      "Garment Made",
      "Sample Made",
      "Block Cutting"
    ],
    embroiedryRightValue: [],
    emb: [{}],
    selectedValueLeft: "",
    selectedValueRight: "",

    //sealingDetails
    sealingDetails: {},
    //otherDetails
    otherDetails: {},

    isLoading: false
  };

  componentDidMount() {
    var { referenceId, styleId } = this.props.location.state;

    StyleServices.getOptionsStyle(styleId, referenceId)
      .then(response => {
        if (response.status == 200) {
          this.setState({
            styleInfo: response.text.data,
            isLoading: true,
            referenceId,
            styleId
          });
        }
      })
      .catch(error => this.props.getalertmessage("error", error.toString()));
  }

  updateValueForkeys = (keyName, name, value) => {
    
    let obj = { ...this.state[keyName] };
    obj[name] = value;
    this.setState({
      [keyName]: obj
    });
  };
  //style func
  updateAdditionalStyleInfo = value => {
    this.setState({
      additionalStyleInformation: value
    });
  };

  //embroidery func start
  moveToRight = () => {
    if (this.state.selectedValueLeft !== "") {
      let embroiedryRightValue = [...this.state.embroiedryRightValue];
      let embroiedryLeftValue = [...this.state.embroiedryLeftValue];

      embroiedryRightValue.push(
        this.state.embroiedryLeftValue[this.state.selectedValueLeft]
      );
      embroiedryLeftValue.splice(this.state.selectedValueLeft, 1);

      this.setState({
        embroiedryRightValue,
        embroiedryLeftValue
      });
    }
  };
  moveToLeft = () => {
    if (this.state.selectedValueRight !== "") {
      let embroiedryRightValue = [...this.state.embroiedryRightValue];
      let embroiedryLeftValue = [...this.state.embroiedryLeftValue];

      embroiedryLeftValue.push(
        this.state.embroiedryRightValue[this.state.selectedValueRight]
      );
      embroiedryRightValue.splice(this.state.selectedValueRight, 1);
      this.setState({
        embroiedryRightValue,
        embroiedryLeftValue
      });
    }
  };
  moveToTop = () => {
   
    if (
      this.state.selectedValueRight !== "" &&
      this.state.embroiedryRightValue.length > 0 &&
      this.state.selectedValueRight != 0
    ) {
      let embroiedryRightValue = [...this.state.embroiedryRightValue];
      let temp = "";
      temp = embroiedryRightValue[this.state.selectedValueRight - 1];
      embroiedryRightValue[this.state.selectedValueRight - 1] =
        embroiedryRightValue[this.state.selectedValueRight];
      embroiedryRightValue[this.state.selectedValueRight] = temp;

      this.setState({
        embroiedryRightValue
      });
      
    }
  };
  moveToBottom = () => {
    if (
      this.state.selectedValueRight !== "" &&
      this.state.embroiedryRightValue.length > 0 &&
      this.state.selectedValueRight !=
        this.state.embroiedryRightValue.length - 1
    ) {
      let embroiedryRightValue = [...this.state.embroiedryRightValue];

      let temp = "";
      temp = embroiedryRightValue[+this.state.selectedValueRight + +1];
      embroiedryRightValue[+this.state.selectedValueRight + +1] =
        embroiedryRightValue[this.state.selectedValueRight];
      embroiedryRightValue[this.state.selectedValueRight] = temp;

      this.setState({
        embroiedryRightValue
      });
      
    }
  };

  //embPlacementAdd
  embPlacementAdd = () => {
    let emb = [...this.state.emb];
    emb.push({});
    this.setState({
      emb
    });
  };

  removeEmbPlacement = i => {
    let emb = [...this.state.emb];
    emb.splice(i, 1);
    this.setState({
      emb
    });
  };
  // embroidery func end

  updateEmbValues = (i, name, value) => {
    let emb = [...this.state.emb];
    emb[i][name] = value;
    this.setState({
      emb
    });
  };

  //order section func start
  addDataOrder = () => {
    let data = [...this.state.data];
    data.push({});
    this.setState({
      data
    });
  };

  removeDataOrder = i => {
    let data = [...this.state.data];
    data.splice(i, 1);
    this.setState({ data });
  };

  uploadFiles = e => {
    let files = e.target.files == 1 ? e.target.files[0] : e.target.files;
    DevelopmentServices.uploadNewImage(files)
      .then(response => {
        if (response.message === "Operation Successful") {
          let orderFileUpload = [...this.state.orderFileUpload];
          response.data.map(value => {
            orderFileUpload.push({
              path: value,
              fileType: ""
            });
          });
          this.setState({
            orderFileUpload
          });
        }
      })
      .catch(error => {
        this.props.getalertMessage('error',error.toString());
      });
  };

  //fileType func
  selectCategory = (value, i) => {
    
    const orderFileUpload = [...this.state.orderFileUpload];
    orderFileUpload[i].fileType = value;
    this.setState({
      orderFileUpload
    });
  };

  //order section func end
  //Trims section func start

  addTrims = () => {
    let trims = [...this.state.trims];
    trims.push({});
    this.setState({
      trims
    });
  };

  removeTrims = i => {
    let trims = [...this.state.trims];
    trims.splice(i, 1);
    this.setState({
      trims
    });
  };

  updateTrimsValues = (i, e) => {
    let trims = [...this.state.trims];
    trims[i][e.target.name] = e.target.value;
    this.setState({ trims });
  };

  saveIb = e => {
    e.preventDefault();
    let data = {};

    //embroidery data
    data.embroiedry = this.state.embroiedry;
    data.embroiedry.emb = this.state.emb;
    data.embroiedry.backingData = this.state.backingData;
    data.embroiedry.array1 = this.state.embroiedryLeftValue;
    data.embroiedry.array2 = this.state.embroiedryRightValue;

    //order data
    data.order = this.state.order;
    data.order.data = this.state.data;

    let orderFileUpload = [...this.state.orderFileUpload];

    let orderFileUploadDup = [];
    orderFileUpload.map((data, index) => {
      orderFileUploadDup.push({
        path: data.path,
        fileType: data.fileType.slice(0, -1)
      });
    });

    data.order.orderFileUpload = orderFileUploadDup;

    //garmentprocess data
    data.garmentProcess = this.state.garmentProcess;

    //emblishmentdetails data
    data.emblishmentDetails = this.state.emblishmentDetails;

    //sealingdetails data
    data.sealingDetails = this.state.sealingDetails;

    //otherdetails data
    data.otherDetails = this.state.otherDetails;

    //magnumStyleid
    data.magnumStyleId = this.state.styleId;

    //referenceid
    data.styleReferenceId = this.state.referenceid;

    StyleServices.saveIB(data)
      .then(response => {
        if (response.status === 200) {
          UtilityService.successMsg(this.msg);
          this.props.history.push("/list", { moduleName: "STYLE" });
        }
      })
      .catch(error => {
        this.props.getalertMessage('error',error.toString());
      });
  };

  historyGo = ()=>{
    // console.log(this.props.history, "historyGo");
    this.props.history.goBack()
  }

  render() {
    // if (
    //   this.state.styleInfo !== undefined &&
    //   Object.keys(this.state.styleInfo).length !== 0 &&
    //   this.state.styleInfo.constructor === Object
    // ) {
    const { styleInfo } = this.state;
    const styleImage = styleInfo.styleImage
      ? "http://192.168.10.121:2024/" + styleInfo.styleImage
      : productImg;
    return (
      this.state.isLoading && (
        <Fragment>
          <div class="right-section">
            <div class="row nopadding">
              <div class="col-md-12 no-padding">
                <span
                  className="p-2 cursor-hover text-left"                  
                  onClick={() => this.historyGo() }
                  title="Go Back"
                >
                  <img width={"20px"} src={leftArrowImage} />
                </span>
                <div
                  class="card-filter meeting-min-con"
                  style={{ marginBottom: "0.5%" }}
                >
                  <div class="row" style={{ padding: "1% 0 1% 0" }}>
                    <div class="col-md-12 product-form">
                      <div class="col-md-12 nopadding ">
                        <div class="col-md-6 nopadding">
                          <h6 className="text-center p-2 pull-right">
                            Create IB
                          </h6>
                        </div>
                        <div class="col-md-6 nopadding">
                          <button
                            type="button"
                            class="primary pull-right px-2 py-1 mr-2"
                          >
                            <i class="fa fa-calendar-check-o font-for-icon-big" />
                          </button>
                        </div>
                      </div>
                      <div
                        class="col-md-11 nopadding"
                        style={{ marginBottom: "1%" }}
                      >
                        <h6 class="text-center text-green">
                          <b>Style Information</b>
                        </h6>
                      </div>
                      {/* STYLE INFORMATION START*/}
                      <StyleInfo
                        styleInfo={styleInfo}
                        styleImage={styleImage}
                        onChange={this.updateAdditionalStyleInfo}
                      />
                      {/* STYLE INFORMATION END*/}
                    </div>
                  </div>
                </div>
                {/* ORDER DETAILS START */}
                <div
                  class="card-filter meeting-min-con"
                  style={{ marginBottom: "0.5%" }}
                >
                  <div class="row" style={{ padding: "1% 0 1% 0" }}>
                    <div class="col-md-12 product-form">
                      <div
                        class="col-md-12 no-padding"
                        style={{ marginBottom: "1%" }}
                      >
                        <h6 class="dev-title">
                          <b>Order Details</b>
                        </h6>
                      </div>
                      {/* ORDER DETAILS ---- SECTION 1 START*/}
                      <div class="col-md-12 nopadding">
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label class="col-md-6" for="item">
                              Tentative Order Confirm Date
                            </label>
                            <input
                              type="date"
                              class="form-control col-md-6"
                              placeholder=""
                              name="tentativeOrderConfirmDate"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "order",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>

                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label class="col-md-6" for="item">
                              Link to Costsheet
                            </label>
                            <input
                              type="text"
                              class="form-control col-md-6"
                              placeholder=""
                              name="costSheet"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "order",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label class="col-md-6" for="item">
                              Order hand Over
                            </label>
                            <input
                              type="date"
                              class="form-control col-md-6"
                              placeholder=""
                              name="orderHandOver"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "order",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label for="ib" class="active col-md-6">
                              Agreed PRice
                            </label>
                            <input
                              type="text"
                              class="form-control col-md-6"
                              placeholder="100.00"
                              name="agreedPrice"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "order",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label class="col-md-6" for="item">
                              PCD at Hand Over
                            </label>
                            <input
                              type="date"
                              class="form-control col-md-6"
                              placeholder=""
                              name="PCDAtHandOver"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "order",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label for="ib" class="active col-md-6">
                              Buying house Margin %
                            </label>
                            <input
                              type="text"
                              class="form-control col-md-6"
                              placeholder="10"
                              name="buyingHouseMargin"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "order",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label class="col-md-6" for="address">
                              Packaging method
                            </label>
                            <select
                              class="form-control col-md-6"
                              name="packingMethod"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "order",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            >
                              <option value="slct">Select</option>
                              <option value="pack">Hanging</option>
                              <option value="pack">Boxed</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label class="col-md-6" for="address">
                              Shipping Mode
                            </label>
                            <select
                              class="form-control col-md-6"
                              name="shippingMethod"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "order",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            >
                              <option value="slct">Select</option>
                              <option value="pack">Hanging</option>
                              <option value="pack">Boxed</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label class="col-md-6" for="address">
                              Packaging Type
                            </label>
                            <select
                              class="form-control col-md-6"
                              name="packingType"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "order",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            >
                              <option value="slct">Select</option>
                              <option value="pack">Hanging</option>
                              <option value="pack">Boxed</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label class="col-md-6" for="address">
                              Shipment Term
                            </label>
                            <input
                              type="text"
                              class="form-control col-md-6"
                              name="shipmentTerm"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "order",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                      {/* ORDER DETAILS ---- SECTION 1 END */}
                      {/* ---------------------------------------------------------------------------------------------------------- */}

                      {/* ORDER DETAILS ---- SECTION 2 START */}
                      {this.state.data.map((aa, i) => (
                        <div class="col-md-12 my-3">
                          <div class="col-md-2 step-one">
                            <div class="form-group">
                              <label for="ib" class="active">
                                Qty
                              </label>
                              <br />
                              <input
                                type="text"
                                class="form-control col-xs-5"
                                placeholder="10"
                                name="quantity"
                                onChange={e => {
                                  let data = [...this.state.data];
                                  data[i][e.target.name] = e.target.value;
                                  this.setState({
                                    data
                                  });
                                }}
                              />
                            </div>
                          </div>

                          <div class="col-md-2 step-one">
                            <div class="form-group">
                              <label class="active">
                                Shipment Date/ into DC
                              </label>
                              <input
                                type="date"
                                class="form-control"
                                placeholder=""
                                name="shipDate"
                                onChange={e => {
                                  let data = [...this.state.data];
                                  data[i][e.target.name] = e.target.value;
                                  this.setState({
                                    data
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div class="col-md-2 step-one">
                            <div class="form-group">
                              <label class="active">Ex-factory Date</label>
                              <input
                                type="date"
                                class="form-control"
                                placeholder=""
                                name="exFactory"
                                onChange={e => {
                                  let data = [...this.state.data];
                                  data[i][e.target.name] = e.target.value;
                                  this.setState({
                                    data
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div class="add-address">
                            {i == 0 ? (
                              <a
                                onClick={() => this.addDataOrder()}
                                class="btn-floating btn-small waves-effect waves-light green address-click-btn"
                              >
                                <i class="material-icons">add</i>
                              </a>
                            ) : (
                              <a
                                onClick={() => this.removeDataOrder(i)}
                                class="btn-floating btn-small waves-effect waves-light red address-click-btn"
                              >
                                <i class="material-icons">clear</i>
                              </a>
                            )}
                          </div>
                        </div>
                      ))}

                      {/* ORDER DETAILS ---- SECTION 2 END */}
                      {/* ---------------------------------------------------------------------------------------------------------- */}
                      {/* ---------------------------------------------------------------------------------------------------------- */}
                      {/* ORDER DETAILS ---- SECTION 3 START */}

                      <div class="col-md-12 my-3">
                        <p> Total Qty: </p>
                        <UploadSection
                          onChangeFileFunc={this.uploadFiles}
                          categories={this.state.categories}
                          onChangeCategoryFunc={this.selectCategory}
                          orderFileUpload={this.state.orderFileUpload}
                        />
                      </div>
                      {/* ORDER DETAILS ---- SECTION 2 END */}
                      {/* ---------------------------------------------------------------------------------------------------------- */}

                      {/* ---------------------------------------------------------------------------------------------------------- */}

                      {/* ORDER DETAILS --- SECTION 3  START*/}
                      <div class="col-md-12 profile-btn text-center">
                        <button class="primary" name="button">
                          SMV/OB CALCULATION/THREAD CONSUMPTION
                        </button>
                        <button class="primary ml-2" name="button">
                          TECHNICAL ISSUES
                        </button>
                      </div>
                      {/* ORDER DETAILS --- SECTION 3 END*/}

                      {/* ---------------------------------------------------------------------------------------------------------- */}

                      {/* ---------------------------------------------------------------------------------------------------------- */}

                      {/* ORDER DETAILS --- ADDITIONAL INFO START*/}
                      <div class="col-md-12">
                        <div class="fabric-textarea">
                          <label for="item">Additional Info</label>
                          <textarea
                            name="additionalInfo"
                            class="form-control"
                            rows="4"
                            cols="80"
                            onChange={e =>
                              this.updateValueForkeys(
                                "order",
                                e.target.name,
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                      {/* ORDER DETAILS --- ADDITION INFO END */}
                      {/* ---------------------------------------------------------------------------------------------------------- */}
                    </div>
                  </div>
                </div>
                {/* ORDER DETAILS END */}

                {/* GARMENT PROCESS START */}
                {/* ---------------------------------------------------------------------------------------------------------- */}

                <div
                  class="card-filter meeting-min-con"
                  style={{ marginBottom: "0.5%" }}
                >
                  <div class="row" style={{ padding: "1% 0 1% 0" }}>
                    <div class="col-md-12 product-form">
                      <div
                        class="col-md-12 no-padding"
                        style={{ marginBottom: "1%" }}
                      >
                        <h6 class="dev-title">
                          <b>Garment Process</b>
                        </h6>
                      </div>
                      {/* GARMENT PROCESS SECTION 1 START */}
                      <div class="col-md-12 my-3 ">
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label for="address">Process Type</label>
                            <select
                              class="form-control"
                              name="processType"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "garmentProcess",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            >
                              <option>Select</option>
                              <option value="Acid Wash">Acid Wash</option>
                              <option value="Soft Washz">Soft Wash</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label for="address">Tolerance</label>
                            <select
                              class="form-control"
                              name="toleranceSheet"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "garmentProcess",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            >
                              <option>Select</option>
                              <option value="wash">
                                Requested/not requested
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label for="address">Laundry Unit</label>
                            <select
                              class="form-control"
                              name="LaundryUnit"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "garmentProcess",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            >
                              <option>Select</option>
                              <option value="Evershine">Evershine</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label for="address">Recipe</label>
                            <div
                              class="upload-box"
                              style={{ display: "block" }}
                            >
                              <FileUploadButton onChange={() => {}} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 my-3 style-td-border" />
                      {/* GARMENT PROCESS ADDITIONAL INFO START */}
                      <div class="col-md-12" style={{ padding: "15px 0 0" }}>
                        <div class="fabric-textarea">
                          <label for="item" class="">
                            Additional Info
                          </label>
                          <textarea
                            name="additionalInfo"
                            class="form-control"
                            rows="4"
                            cols="80"
                            onChange={e =>
                              this.updateValueForkeys(
                                "garmentProcess",
                                e.target.name,
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                      {/*GARMENT PROCESS ADDITIONAL INFO END  */}
                    </div>
                  </div>
                </div>
                {/* ---------------------------------------------------------------------------------------------------------- */}
                {/* GARMENT PROCESS END */}

                {/* FABRIC START */}
                {/* ---------------------------------------------------------------------------------------------------------- */}

                <div
                  class="card-filter meeting-min-con"
                  style={{ marginBottom: "0.5%" }}
                >
                  <div class="row" style={{ padding: "1% 0 1% 0" }}>
                    <div class="col-md-12 product-form">
                      {/* SECTION 1 START*/}
                      <div class="col-md-12 nopadding">
                        <a class="btn-floating btn-small waves-effect waves-light green pull-right">
                          <i class="material-icons">add</i>
                        </a>
                      </div>
                      {/* SECTION 1 END*/}
                      {/* SECTION 2 START*/}
                      <div class="col-md-12 nopadding">
                        <label>FABRIC NO</label>
                        {true ? (
                          <span
                            className="positioing-end pr-3"
                            onClick={e => this.changeToggleList(e, "dispatch")}
                          >
                            <i className="fa fa-angle-up" />
                          </span>
                        ) : (
                          <span
                            className="positioing-end pr-3"
                            onClick={e => this.changeToggleList(e, "dispatch")}
                          >
                            <i className="fa fa-angle-down" />
                          </span>
                        )}
                      </div>
                      {/* SECTION 2 END*/}
                      {/* SECTION 3 START*/}
                      <div class="col-md-12 nopadding">
                        {/* FABRIC DETAILS */}
                        <div class="col-md-6 nopadding">
                          <div>Fabric Details</div>
                          <div class="card-light ib-list-view">
                            <ul class="main-list">
                              <li>
                                <ul>
                                  <li>Position</li>
                                  <li>
                                    <select
                                      class="form-control"
                                      name="Position"
                                      onChange={e =>
                                        this.updateValueForkeys(
                                          "fabric",
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option>Select</option>
                                      <option value="wash">Evershine</option>
                                    </select>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <ul>
                                  <li>Fabric No </li>
                                  <li>42590</li>
                                </ul>
                              </li>
                              <li>
                                <ul>
                                  <li>Fabric origination </li>
                                  <li>
                                    <select
                                      class="form-control"
                                      name="fabricOrigination"
                                      onChange={e =>
                                        this.updateValueForkeys(
                                          "fabric",
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option value="slct">Select</option>
                                      <option value="wash">Evershine</option>
                                    </select>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <ul>
                                  <li>Development Type </li>
                                  <li>
                                    <select
                                      class="form-control"
                                      name="developmentType"
                                      onChange={e =>
                                        this.updateValueForkeys(
                                          "fabric",
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option>Select</option>
                                      <option value="wash">Evershine</option>
                                    </select>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <ul>
                                  <li>Submission Date </li>
                                  <li>
                                    <input
                                      type="date"
                                      class="form-control"
                                      name="submissionDate"
                                      onChange={e =>
                                        this.updateValueForkeys(
                                          "fabric",
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <ul>
                                  <li>Approval Date </li>
                                  <li>
                                    <input
                                      type="date"
                                      class="form-control"
                                      name="approvalDate"
                                      onChange={e =>
                                        this.updateValueForkeys(
                                          "fabric",
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <ul>
                                  <li>1st of Bulk Submission ETA </li>
                                  <li>
                                    <input
                                      type="date"
                                      class="form-control"
                                      name="firstOfBulkSubmissionETA"
                                      onChange={e =>
                                        this.updateValueForkeys(
                                          "fabric",
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <ul>
                                  <li>Flow Start </li>
                                  <li>
                                    <input
                                      type="date"
                                      class="form-control"
                                      name="flowStart"
                                      onChange={e =>
                                        this.updateValueForkeys(
                                          "fabric",
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <ul>
                                  <li>Flow Stop</li>
                                  <li>
                                    <input
                                      type="date"
                                      class="form-control"
                                      name="flowStop"
                                      onChange={e =>
                                        this.updateValueForkeys(
                                          "fabric",
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <ul>
                                  <li>Are you working on options?</li>
                                  <li>
                                    <select
                                      class="form-control"
                                      name="isWorkingOnOptions"
                                      onChange={e =>
                                        this.setState({
                                          [e.target.name]: e.target.value
                                        })
                                      }
                                    >
                                      <option value="yes">Yes</option>
                                      <option value="no">No</option>
                                    </select>
                                  </li>
                                </ul>
                              </li>
                              {this.state.isWorkingOnOptions === "yes" ? (
                                <Fragment>
                                  <li>
                                    <ul>
                                      <li>Development Type</li>
                                      <li>
                                        <select
                                          class="form-control"
                                          name="developmentType"
                                          onChange={e =>
                                            this.updateValueForkeys(
                                              "fabric",
                                              e.target.name,
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option>select</option>
                                          <option value="no">Labdip</option>
                                        </select>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <ul>
                                      <li>1st Submission Date</li>
                                      <li>
                                        <input
                                          type="date"
                                          class="form-control"
                                          name="firstSubmissionDate"
                                          onChange={e =>
                                            this.updateValueForkeys(
                                              "fabric",
                                              e.target.name,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <ul>
                                      <li>2nd Submission Date</li>
                                      <li>
                                        <input
                                          type="date"
                                          class="form-control"
                                          name="secondSubmissionDate"
                                          onChange={e =>
                                            this.updateValueForkeys(
                                              "fabric",
                                              e.target.name,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <ul>
                                      <li>Flow Start</li>
                                      <li>
                                        <input
                                          type="date"
                                          class="form-control"
                                          name="flowStart2"
                                          onChange={e =>
                                            this.updateValueForkeys(
                                              "fabric",
                                              e.target.name,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <ul>
                                      <li>Flow Stop</li>
                                      <li>
                                        <input
                                          type="date"
                                          class="form-control"
                                          name="flowStop2"
                                          onChange={e =>
                                            this.updateValueForkeys(
                                              "fabric",
                                              e.target.name,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </li>
                                    </ul>
                                  </li>
                                </Fragment>
                              ) : (
                                <Fragment>
                                  <li>
                                    <ul>
                                      <li>Sealer Ydg</li>
                                      <li>
                                        <select
                                          class="form-control"
                                          name="sealerYdg"
                                          onChange={e =>
                                            this.updateValueForkeys(
                                              "fabric",
                                              e.target.name,
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option>select</option>
                                          <option value="no">Labdip</option>
                                        </select>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <ul>
                                      <li>Status</li>
                                      <li>
                                        <select
                                          class="form-control"
                                          name="sealerYdg"
                                          onChange={e =>
                                            this.updateValueForkeys(
                                              "fabric",
                                              e.target.name,
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option>select</option>
                                          <option value="no">Labdip</option>
                                        </select>
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    <ul>
                                      <li>ETA </li>
                                      <li>
                                        <input
                                          type="date"
                                          class="form-control"
                                          name="approvalDate"
                                          onChange={e =>
                                            this.updateValueForkeys(
                                              "fabric",
                                              e.target.name,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </li>
                                    </ul>
                                  </li>
                                </Fragment>
                              )}
                            </ul>
                          </div>
                        </div>
                        {/* TESTING DETAILS START*/}
                        <div class="col-md-6 nopadding">
                          <div>Testing Details</div>
                          <div class="card-light ib-list-view">
                            <ul class="main-list">
                              <li>
                                <ul>
                                  <li>Base Approval Status</li>
                                  <li>
                                    <select
                                      class="form-control"
                                      name="baseApproval"
                                      onChange={e =>
                                        this.updateValueForkeys(
                                          "testDetails",
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option value="slct">Select</option>
                                      <option value="wash">Evershine</option>
                                    </select>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <ul>
                                  <li>BNO</li>
                                  <li>42590</li>
                                </ul>
                              </li>
                              <li>
                                <ul>
                                  <li>Can you proceed with FOM?</li>
                                  <li>
                                    <select
                                      class="form-control"
                                      name="processWithFOM"
                                      onChange={e =>
                                        this.updateValueForkeys(
                                          "testDetails",
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option value="slct">Select</option>
                                      <option value="wash">Evershine</option>
                                    </select>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <ul>
                                  <li>Magnum Risk</li>
                                  <li>
                                    <select
                                      class="form-control"
                                      name="magnumRisk"
                                      onChange={e =>
                                        this.updateValueForkeys(
                                          "testDetails",
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option value="slct">Select</option>
                                      <option value="wash">Evershine</option>
                                    </select>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </div>
                        </div>
                        {/* TESTING DETAILS END*/}
                      </div>
                      {/* SECTION 3 END*/}
                      {/* SECTION 4 START*/}
                      <div class="col-md-12 py-3">
                        <div class="col-md-3 step-one">
                          <div class="form-group form-inline">
                            <label for="ib" class="active">
                              Fabric Ref no
                            </label>
                            <br />
                            <input
                              type="text"
                              class="form-control col-xs-5 ml-1"
                              placeholder="10"
                            />
                          </div>
                        </div>

                        <div class="col-md-2 step-one">
                          <div class="form-group form-inline">
                            <label class="active">Qty</label>
                            <input
                              type="date"
                              class="form-control ml-1"
                              placeholder=""
                            />
                          </div>
                        </div>
                        <div class="col-md-2 step-one">
                          <label class="pt-2">Check Report</label>
                        </div>
                        <div class="col-md-2">
                          <FileUploadButton onChange={() => {}} />
                        </div>
                      </div>
                      {/* SECTION 4 END*/}
                      {/* SECTION 5 START */}
                      {/* UPLOAD SECTION */}
                      <div className="col-md-12 view-ib-right style-td-border">
                        <ul className="list-inline pt-3">
                          {this.state.uploadedFiles.map((image, index) => (
                            <li
                              key={index}
                              className="img-responsive-fill-list p-3"
                            >
                              {" "}
                              <img
                                src={window.URL.createObjectURL(image)}
                                className="mr-2"
                              />
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* SECTION 5 END */}
                    </div>
                  </div>
                </div>

                {/* ---------------------------------------------------------------------------------------------------------- */}
                {/* FABRIC END */}

                {/* TRIM START */}
                {/* ---------------------------------------------------------------------------------------------------------- */}

                <div
                  class="card-filter meeting-min-con"
                  style={{ marginBottom: "0.5%" }}
                >
                  <div class="row" style={{ padding: "1% 0 1% 0" }}>
                    <div class="col-md-12 product-form">
                      <div
                        class="col-md-12 no-padding"
                        style={{ marginBottom: "1%" }}
                      >
                        <h6 class="dev-title">
                          <b>Trims</b>
                        </h6>
                      </div>
                      <div class="col-md-12 nopadding thickBorder p-3">
                        {this.state.trims.map((data, i) => (
                          <Fragment>
                            {i == 0 ? (
                              <a
                                onClick={() => this.addTrims()}
                                class="btn-floating btn-small waves-effect waves-light green address-click-btn pull-right"
                              >
                                <i class="material-icons">add</i>
                              </a>
                            ) : (
                              <a
                                onClick={() => this.removeTrims(i)}
                                class="btn-floating btn-small waves-effect waves-light red address-click-btn pull-right"
                              >
                                <i class="material-icons">clear</i>
                              </a>
                            )}
                            <table class="table">
                              <thead class="border-bottom-0">
                                <tr class="border-bottom-0">
                                  <th
                                    class="border-bottom-0 text-left"
                                    width="9.09090909091%"
                                  >
                                    {" "}
                                    Trim Category
                                  </th>
                                  <th
                                    class="border-bottom-0 text-left"
                                    width="9.09090909091%"
                                  >
                                    {" "}
                                    Trim Ref No.
                                  </th>
                                  <th
                                    class="border-bottom-0 text-left"
                                    width="9.09090909091%"
                                  >
                                    {" "}
                                    Description
                                  </th>
                                  <th
                                    class="border-bottom-0 text-left"
                                    width="9.09090909091%"
                                  >
                                    {" "}
                                    Quality
                                  </th>
                                  <th
                                    class="border-bottom-0 text-left"
                                    width="9.09090909091%"
                                  >
                                    {" "}
                                    Supplier
                                  </th>
                                  <th
                                    class="border-bottom-0 text-left"
                                    width="9.09090909091%"
                                  >
                                    {" "}
                                    Size
                                  </th>
                                  <th
                                    class="border-bottom-0 text-left"
                                    width="9.09090909091%"
                                  >
                                    {" "}
                                    Price/Unit
                                  </th>
                                  <th
                                    class="border-bottom-0 text-left"
                                    width="9.09090909091%"
                                  >
                                    {" "}
                                    Trigger Date
                                  </th>
                                  <th
                                    class="border-bottom-0 text-left"
                                    width="9.09090909091%"
                                  >
                                    {" "}
                                    Col Status
                                  </th>
                                  <th
                                    class="border-bottom-0 text-left"
                                    width="9.09090909091%"
                                  >
                                    Labdip ETA{" "}
                                  </th>
                                  <th
                                    class="border-bottom-0 text-left"
                                    width="9.09090909091%"
                                  >
                                    {" "}
                                    Special Trims Testing
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="border-top-0">
                                    <select
                                      class="form-control"
                                      name="category"
                                      onChange={e =>
                                        this.updateTrimsValues(i, e)
                                      }
                                    >
                                      <option value="">Select</option>
                                      <option value="button">Button</option>
                                    </select>
                                  </td>
                                  <td class="border-top-0">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="TBU-101"
                                      name="trimRefNumber"
                                      onChange={e =>
                                        this.updateTrimsValues(i, e)
                                      }
                                    />
                                  </td>
                                  <td class="border-top-0">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="TBU-101"
                                      name="description"
                                      onChange={e =>
                                        this.updateTrimsValues(i, e)
                                      }
                                    />
                                  </td>
                                  <td class="border-top-0">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="TBU-101"
                                      name="quality"
                                      onChange={e =>
                                        this.updateTrimsValues(i, e)
                                      }
                                    />
                                  </td>
                                  <td class="border-top-0">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="TBU-101"
                                      name="price"
                                      onChange={e =>
                                        this.updateTrimsValues(i, e)
                                      }
                                    />
                                  </td>
                                  <td class="border-top-0">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="TBU-101"
                                      name="supplier"
                                      onChange={e =>
                                        this.updateTrimsValues(i, e)
                                      }
                                    />
                                  </td>
                                  <td class="border-top-0">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="TBU-101"
                                      name="size"
                                      onChange={e =>
                                        this.updateTrimsValues(i, e)
                                      }
                                    />
                                  </td>
                                  <td class="border-top-0">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="TBU-101"
                                      name="triggerDate"
                                      onChange={e =>
                                        this.updateTrimsValues(i, e)
                                      }
                                    />
                                  </td>
                                  <td class="border-top-0">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="TBU-101"
                                      name="colStatus"
                                      onChange={e =>
                                        this.updateTrimsValues(i, e)
                                      }
                                    />
                                  </td>
                                  <td class="border-top-0">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="TBU-101"
                                      name="labDipETA"
                                      onChange={e =>
                                        this.updateTrimsValues(i, e)
                                      }
                                    />
                                  </td>
                                  <td class="border-top-0">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="TBU-101"
                                      name="leadTime"
                                      onChange={e =>
                                        this.updateTrimsValues(i, e)
                                      }
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </Fragment>
                        ))}
                      </div>
                      <div class="col-md-12" style={{ padding: "15px 0 0" }}>
                        <div class="fabric-textarea">
                          <label for="item" class="">
                            Additional Info
                          </label>
                          <textarea
                            name="trimAdditionalInfo"
                            class="form-control"
                            rows="4"
                            cols="80"
                            onChange={e => {
                              this.setState({
                                trimAdditionalInfo: e.target.value
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ---------------------------------------------------------------------------------------------------------- */}

                {/* TRIM END */}

                {/* EMBROIDERY START */}
                {/* ---------------------------------------------------------------------------------------------------------- */}

                <div
                  class="card-filter meeting-min-con"
                  style={{ marginBottom: "0.5%" }}
                >
                  <div class="row" style={{ padding: "1% 0 1% 0" }}>
                    <div class="col-md-12 product-form">
                      <div class="col-md-12 no-padding">
                        <h6
                          class="dev-title"
                          style={{ paddingBottom: "10px", float: "left" }}
                        >
                          <b>Embroidery</b>
                        </h6>
                      </div>
                      <form name="embroideryForm">
                        <div class="col-md-12 nopadding">
                          <div class="col-md-6 step-one">
                            <div class="form-group">
                              <label class="col-md-6 active" for="item">
                                Emb Design{" "}
                              </label>
                              <select
                                class="form-control col-md-6"
                                name="embDesign"
                                onChange={e =>
                                  this.updateValueForkeys(
                                    "embroiedry",
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              >
                                <option>Select</option>
                                <option value="approved">Approved</option>
                                <option value="notapproved">
                                  Not Approved
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-md-6 step-one">
                            <div class="form-group">
                              <label class="col-md-4 active" for="item">
                                Design Sheet{" "}
                              </label>
                              <select
                                class="form-control col-md-4"
                                name="designSignSheet"
                                onChange={e =>
                                  this.updateValueForkeys(
                                    "embroiedry",
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              >
                                <option>Select</option>
                                <option value="attached">Attached</option>
                                <option value="notattached">
                                  Not Attached
                                </option>
                              </select>
                              <div
                                class="upload-box col-md-4"
                                style={{ display: "block" }}
                              >
                                <FileUploadButton onChange={() => {}} />
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6 step-one">
                            <div class="form-group">
                              <label class="col-md-6 active" for="item">
                                Grading{" "}
                              </label>
                              <select
                                class="form-control col-md-6"
                                name="grading"
                                onChange={e =>
                                  this.updateValueForkeys(
                                    "embroiedry",
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              >
                                <option>Select</option>
                                <option value="agreed">Agreed</option>
                                <option value="notagreed">Not Agreed</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-md-6 step-one">
                            <Field
                              isFormGroup={true}
                              inputType="checkboxToggle"
                              inputName="smocking"
                              value={this.state.smocking}
                              label="Bit Attaching"
                              onChange={(name, value) =>
                                this.setState({ [name]: value })
                              }
                              disabled={this.state.disabled}
                            />
                          </div>
                          <div class="col-md-6 step-one">
                            <div class="form-group">
                              <label class="col-md-6 active" for="item">
                                Emb Thread Approval
                              </label>
                              <select
                                class="form-control col-md-6"
                                name="embThreadApproval"
                                onChange={e =>
                                  this.updateValueForkeys(
                                    "embroiedry",
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              >
                                <option>Select</option>
                                <option value="approved">Approved</option>
                                <option value="notapproved">
                                  Not Approved
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-md-6 step-one">
                            <div class="form-group">
                              <label class="col-md-6 active" for="item">
                                Further Info
                              </label>
                              <input
                                type="text"
                                class="form-control col-md-6"
                                name="furtherInfo"
                                onChange={e =>
                                  this.updateValueForkeys(
                                    "embroiedry",
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          </div>
                        </div>
                        {/* Start of Content Embroiedry */}
                        <div className="col-md-12 embroid-mul">
                          <div className="col-md-2 step-one text-center">
                            <p className="manage_permissions emb-chck">
                              <input
                                type="checkbox"
                                className="filled-in"
                                id="filled-in-box1"
                                checked={this.state.embroiedry.cutPanel}
                                onChange={e => {
                                  let embroidery = {
                                    ...this.state.embroiedry
                                  };
                                  embroidery.cutPanel !=
                                    this.state.embroiedry.cutPanel;
                                  this.setState({ embroidery });
                                }}
                              />
                              <label for="filled-in-box1">Cut Panel</label>
                            </p>
                          </div>
                          <div className="col-md-2 step-one text-center">
                            <p className="manage_permissions emb-chck">
                              <input
                                type="checkbox"
                                className="filled-in"
                                id="filled-in-box2"
                                checked={this.state.embroiedry.allOver}
                                onChange={e => {
                                  let embroidery = {
                                    ...this.state.embroiedry
                                  };
                                  embroidery.allOver !=
                                    this.state.embroiedry.allOver;
                                  this.setState({ embroidery });
                                }}
                              />
                              <label for="filled-in-box2">All Over</label>
                            </p>
                          </div>
                          <div className="col-md-2 step-one text-center">
                            <p className="manage_permissions emb-chck">
                              <input
                                type="checkbox"
                                className="filled-in"
                                id="filled-in-box3"
                                checked={this.state.embroiedry.garmentForm}
                                onChange={e => {
                                  let embroidery = {
                                    ...this.state.embroiedry
                                  };
                                  embroidery.garmentForm !=
                                    this.state.embroiedry.garmentForm;
                                  this.setState({ embroidery });
                                }}
                              />
                              <label for="filled-in-box3">Garment Form</label>
                            </p>
                          </div>
                          <div className="col-md-3 step-one text-center">
                            <p className="manage_permissions emb-chck">
                              <input
                                type="checkbox"
                                className="filled-in"
                                id="filled-in-box4"
                                checked={this.state.embroiedry.semiGarmentForm}
                                onChange={e => {
                                  let embroidery = {
                                    ...this.state.embroiedry
                                  };
                                  embroidery.semiGarmentForm !=
                                    this.state.embroiedry.semiGarmentForm;
                                  this.setState({ embroidery });
                                }}
                              />
                              <label for="filled-in-box4">
                                Semi garment Form
                              </label>
                            </p>
                          </div>
                          <div className="col-md-2 step-one text-center">
                            <p className="manage_permissions emb-chck">
                              <input
                                type="checkbox"
                                className="filled-in"
                                id="filled-in-box5"
                                checked={this.state.embroiedry.tassle}
                                onChange={e => {
                                  let embroidery = {
                                    ...this.state.embroiedry
                                  };
                                  embroidery.tassle !=
                                    this.state.embroiedry.tassle;
                                  this.setState({ embroidery });
                                }}
                              />
                              <label for="filled-in-box5">Tassle</label>
                            </p>
                          </div>
                        </div>
                        <div className="col-md-8 col-md-offset-2 no-padding">
                          <div className="process-allocation">
                            <div className="process-alloc-con process-left-con col-md-4 no-padding">
                              <select
                                id="mySelect"
                                className="mySelectLeft"
                                size="10"
                                style={{ display: "block" }}
                                onChange={e => {
                                  this.setState({
                                    selectedValueLeft: e.target.value
                                  });
                                }}
                              >
                                {this.state.embroiedryLeftValue.map(
                                  (data, i) => (
                                    <option value={i}>{data}</option>
                                  )
                                )}
                              </select>
                            </div>
                            {/* end of process-alloc-con */}
                            <div className="process-left-arrows">
                              <a href="#" onClick={() => this.moveToRight()}>
                                <span className="up">
                                  <i className="fa fa-chevron-right" />
                                </span>
                              </a>
                              <a href="#" onClick={() => this.moveToBottom()}>
                                <span className="down">
                                  <i className="fa fa-chevron-down" />
                                </span>
                              </a>
                            </div>
                            <div className="process-alloc-con col-md-4 no-padding">
                              <select
                                id="mySelect2"
                                className="mySelectRight"
                                size="10"
                                style={{ display: "block" }}
                                onChange={e => {
                                  this.setState({
                                    selectedValueRight: e.target.value
                                  });
                                }}
                              >
                                {this.state.embroiedryRightValue.map(
                                  (data, i) => (
                                    <option value={i}>{data}</option>
                                  )
                                )}
                              </select>
                            </div>
                            {/* end of process-alloc-con */}
                            <div className="process-nav-arrows">
                              <a href="#" onClick={() => this.moveToTop()}>
                                <span className="up">
                                  <i className="fa fa-chevron-up" />
                                </span>
                              </a>
                              <a href="#" onClick={() => this.moveToLeft()}>
                                <span className="down">
                                  <i className="fa fa-chevron-left" />
                                </span>
                              </a>
                            </div>
                          </div>
                          {/* end of process-allocation */}
                        </div>
                        <div class="col-md-12 nopadding">
                          <table class="table">
                            <thead class="border-bottom-0">
                              <tr class="border-bottom-0">
                                <th
                                  class="border-bottom-0 text-left"
                                  width="11.1111111111%"
                                >
                                  Emb Placement
                                </th>
                                <th
                                  class="border-bottom-0 text-left"
                                  width="11.1111111111%"
                                >
                                  Emb form
                                </th>
                                <th
                                  class="border-bottom-0 text-left"
                                  width="11.1111111111%"
                                >
                                  No of Colors
                                </th>
                                <th
                                  class="border-bottom-0 text-left"
                                  width="11.1111111111%"
                                >
                                  Frames
                                </th>
                                <th
                                  class="border-bottom-0 text-left"
                                  width="11.1111111111%"
                                >
                                  Stitches/Mtr
                                </th>
                                <th
                                  class="border-bottom-0 text-left"
                                  width="11.1111111111%"
                                >
                                  Consumption/Unit
                                </th>
                                <th
                                  class="border-bottom-0 text-left"
                                  width="11.1111111111%"
                                />
                                <th
                                  class="border-bottom-0 text-left"
                                  width="11.1111111111%"
                                >
                                  Stitches Count
                                </th>
                                <th
                                  class="border-bottom-0 text-left"
                                  width="11.1111111111%"
                                >
                                  Prices/1000 Stitches
                                </th>
                                <th
                                  class="border-bottom-0 text-left"
                                  width="11.1111111111%"
                                >
                                  Total(INR)
                                </th>
                                <th
                                  class="border-bottom-0 text-left"
                                  width="11.1111111111%"
                                />
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.emb.map((data, i) => (
                                <tr>
                                  <td class="border-top-0">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder=""
                                      name="embPlacement"
                                      onChange={e =>
                                        this.updateEmbValues(
                                          i,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </td>
                                  <td class="border-top-0">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder=""
                                      name="embForm"
                                      onChange={e =>
                                        this.updateEmbValues(
                                          i,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </td>
                                  <td class="border-top-0">
                                    <select
                                      class="form-control"
                                      name="noOfCols"
                                      onChange={e =>
                                        this.updateEmbValues(
                                          i,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option value="style">Select</option>
                                      <option value={1}>1</option>
                                      <option value={2}>2</option>
                                      <option value={3}>3</option>
                                      <option value={4}>4</option>
                                      <option value={5}>5</option>
                                      <option value={6}>6</option>
                                      <option value={7}>7</option>
                                      <option value={8}>8</option>
                                      <option value={9}>9</option>
                                      <option value={10}>10</option>
                                    </select>
                                  </td>
                                  <td class="border-top-0">
                                    <select
                                      class="form-control"
                                      name="frames"
                                      onChange={e =>
                                        this.updateEmbValues(
                                          i,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option value="style">Select</option>
                                      <option value={1}>1</option>
                                      <option value={2}>2</option>
                                      <option value={3}>3</option>
                                      <option value={4}>4</option>
                                      <option value={5}>5</option>
                                      <option value={6}>6</option>
                                      <option value={7}>7</option>
                                      <option value={8}>8</option>
                                      <option value={9}>9</option>
                                      <option value={10}>10</option>
                                    </select>
                                  </td>
                                  <td class="border-top-0">
                                    <input
                                      type="number"
                                      min="0"
                                      class="form-control"
                                      name={"stitchesPerMrt"}
                                      onChange={e =>
                                        this.updateEmbValues(
                                          i,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </td>
                                  <td class="border-top-0">
                                    <input
                                      type="number"
                                      min="0"
                                      class="form-control"
                                      name={"consumption"}
                                      onChange={e =>
                                        this.updateEmbValues(
                                          i,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </td>
                                  <td class="border-top-0" />
                                  <td class="border-top-0">
                                    <input
                                      type="number"
                                      min="0"
                                      class="form-control"
                                      name={"stitchesCount"}
                                      onChange={e =>
                                        this.updateEmbValues(
                                          i,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </td>
                                  <td class="border-top-0">
                                    <input
                                      type="text"
                                      class="form-control"
                                      name={"pricePer1000Stitches"}
                                      onChange={e =>
                                        this.updateEmbValues(
                                          i,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </td>
                                  <td class="border-top-0">
                                    <input
                                      type="text"
                                      class="form-control"
                                      name={"totalValue"}
                                      value={(
                                        (this.state.emb[i].stitchesCount *
                                          this.state.emb[i]
                                            .pricePer1000Stitches) /
                                        1000
                                      ).toFixed(2)}
                                    />
                                  </td>
                                  <td class="border-top-0 pt-0">
                                    <a
                                      style={
                                        i === 0
                                          ? { display: "block" }
                                          : { display: "none" }
                                      }
                                      class="btn-floating btn-small waves-effect waves-light green pull-right"
                                      onClick={e => this.embPlacementAdd()}
                                    >
                                      <i class="material-icons">add</i>
                                    </a>
                                    <a
                                      style={
                                        i !== 0
                                          ? { display: "block" }
                                          : { display: "none" }
                                      }
                                      className="btn-floating btn-small waves-effect waves-light red del-customer-info-btn pull-right"
                                      id="del-customer-info-btn"
                                      onClick={() => this.removeEmbPlacement(i)}
                                    >
                                      <i className="material-icons">clear</i>
                                    </a>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <div class="col-md-12 no-padding">
                          <div class="col-md-1 step-one">
                            <Field
                              isFormGroup={true}
                              inputType="checkboxToggle"
                              inputName="backing"
                              value={this.state.backing}
                              label="Backing"
                              onChange={(name, value) =>
                                this.setState({ [name]: value })
                              }
                              disabled={this.state.disabled}
                            />
                          </div>
                          {this.state.embroiedry.backing && (
                            <div class="col-md-12 nopadding">
                              <div class="col-md-12 nopadding">
                                <label for="sample">Backing</label>
                                <br />
                              </div>
                              <div class="col-md-12 nopadding">
                                <div class="col-md-6 nopadding">
                                  <div className="col-md-2 step-one">
                                    <div className="form-group">
                                      <label>Backing</label>
                                      <select
                                        class="form-control"
                                        name="backingValue"
                                        onChange={e =>
                                          this.updateValueForkeys(
                                            "backingData",
                                            e.target.name,
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option>select</option>
                                        <option value={"paper"}>Paper</option>
                                        <option value={"waterSoluble"}>
                                          WaterSoluble
                                        </option>
                                        <option value={"NA"}>NA</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-md-2 step-one">
                                    <div className="form-group">
                                      <label>Width</label>
                                      <input
                                        name="backingWidth"
                                        onChange={e =>
                                          this.updateValueForkeys(
                                            "backingData",
                                            e.target.name,
                                            e.target.value
                                          )
                                        }
                                        type="number"
                                        class="form-control"
                                        placeholder="TBN-00659"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-2 step-one">
                                    <div className="form-group">
                                      <label>Placement</label>
                                      <input
                                        name="backingPlacement"
                                        onChange={e =>
                                          this.updateValueForkeys(
                                            "backingData",
                                            e.target.name,
                                            e.target.value
                                          )
                                        }
                                        type="number"
                                        class="form-control"
                                        placeholder="TBN-00659"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6 nopadding">
                                  <div className="col-md-2 step-one pull-right">
                                    <div className="form-group">
                                      <label>Total(INR)</label>
                                      <input
                                        type="number"
                                        min={0}
                                        name="price"
                                        class="form-control"
                                        placeholder="0.38 mts"
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-2 step-one pull-right">
                                    <div className="form-group">
                                      <label>Price/Mtr</label>
                                      <input
                                        type="number"
                                        min={0}
                                        name="pricedMtr"
                                        onChange={e =>
                                          this.updateValueForkeys(
                                            "backingData",
                                            e.target.name,
                                            e.target.value
                                          )
                                        }
                                        class="form-control"
                                        placeholder="0.38 mts"
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-2 step-one pull-right">
                                    <div className="form-group">
                                      <label>Consumption</label>
                                      <input
                                        type="text"
                                        name="consumption"
                                        onChange={e =>
                                          this.updateValueForkeys(
                                            "backingData",
                                            e.target.name,
                                            e.target.value
                                          )
                                        }
                                        class="form-control"
                                        onChange={e =>
                                          this.setState({
                                            [e.target.name]: e.target.value
                                          })
                                        }
                                        placeholder="-"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        {/* End of content embroiedry */}
                      </form>
                      <div class="col-md-12" style={{ padding: "15px 0 0" }}>
                        <div class="fabric-textarea">
                          <label for="item" class="">
                            Additional Info
                          </label>
                          <textarea
                            name="name"
                            class="form-control"
                            rows="4"
                            cols="80"
                            name="additionaDetails"
                            onChange={e =>
                              this.updateValueForkeys(
                                "embroiedry",
                                e.target.name,
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* EMBROIDERY END */}
                {/* ---------------------------------------------------------------------------------------------------------- */}

                {/* ---------------------------------------------------------------------------------------------------------- */}
                {/* EMBELLISHMENT START*/}
                <div
                  class="card-filter meeting-min-con"
                  style={{ marginBottom: "0.5%" }}
                >
                  <div class="row" style={{ padding: "1% 0 1% 0" }}>
                    <div class="col-md-12 product-form">
                      {/* TITLE OF EMBELLISHMENT */}
                      <div
                        class="col-md-12 no-padding"
                        style={{ marginBottom: "1%" }}
                      >
                        <h6 class="dev-title">
                          <b>EMBELLISHMENT</b>
                        </h6>
                      </div>
                      {/* SECTION 1 */}
                      <div class="col-md-12 nopadding">
                        <div class="col-md-6 nopadding">
                          <div class="col-md-12 step-one">
                            <div class="form-group">
                              <label class="col-md-6 active" for="item">
                                Embellishment Design{" "}
                              </label>
                              <select
                                class="form-control col-md-6"
                                name="emblishmentDesign"
                                onChange={e =>
                                  this.updateValueForkeys(
                                    "emblishmentDetails",
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              >
                                <option>Select</option>
                                <option value="approved">Approved</option>
                                <option value="notapproved">
                                  Not Approved
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-md-12 step-one">
                            <div class="form-group">
                              <label class="col-md-6 active" for="item">
                                Grading
                              </label>
                              <select
                                class="form-control col-md-6"
                                name="grading"
                                onChange={e =>
                                  this.updateValueForkeys(
                                    "emblishmentDetails",
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              >
                                <option>Select</option>
                                <option value="agreed">Agreed</option>
                                <option value="notagreed">Not Agreed</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 step-one nopadding">
                          <Field
                            isFormGroup={true}
                            inputType="checkboxToggle"
                            inputName="bitAttaching"
                            value={this.state.bitAttaching}
                            label="Bit Attaching"
                            onChange={(name, value) =>
                              this.setState({ [name]: value })
                            }
                            disabled={this.state.disabled}
                          />
                        </div>
                      </div>
                      <div class="col-md-12 nopadding">
                        <h6 class="dev-title">
                          <b>EMBELLISHMENT COST DETAILS</b>
                        </h6>
                      </div>
                      <div class="col-md-12 nopadding">
                        <a class="btn-floating btn-small waves-effect waves-light green pull-right">
                          <i class="material-icons">add</i>
                        </a>
                        <div class="col-md-2 step-one pl-0">
                          <div class="form-group">
                            <label for="">Type</label>
                            <input
                              type="text"
                              class="form-control"
                              name="embellismentType"
                              name="buyingSampleDated"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "emblishmentDetails",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-2 step-one pl-0">
                          <div class="form-group">
                            <label for="">HH:MM</label>
                            <input
                              type="text"
                              class="form-control"
                              name="embellismentType"
                              name="buyingSampleDated"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "emblishmentDetails",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-2 step-one pl-0">
                          <div class="form-group">
                            <label for="">Price/30mins</label>
                            <input
                              type="text"
                              class="form-control"
                              name="embellismentType"
                              name="buyingSampleDated"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "emblishmentDetails",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                      {/* Additional info */}
                      <div class="col-md-12" style={{ padding: "15px 0 0" }}>
                        <div class="fabric-textarea">
                          <label for="item" class="">
                            Additional Info
                          </label>
                          <textarea
                            name="name"
                            class="form-control"
                            rows="4"
                            cols="80"
                            name="buyingSampleDated"
                            onChange={e =>
                              this.updateValueForkeys(
                                "emblishmentDetails",
                                e.target.name,
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* EMBELLISHMENT END */}
                {/* ---------------------------------------------------------------------------------------------------------- */}

                {/* ---------------------------------------------------------------------------------------------------------- */}

                {/* SEALING START */}
                <div
                  class="card-filter meeting-min-con"
                  style={{ marginBottom: "0.5%" }}
                >
                  <div class="row" style={{ padding: "1% 0 1% 0" }}>
                    <div class="col-md-12 product-form">
                      {/* TITLE  */}
                      <div
                        class="col-md-12 no-padding"
                        style={{ marginBottom: "1%" }}
                      >
                        <h6 class="dev-title">
                          <b>SEALING DETAILS</b>
                        </h6>
                      </div>
                      {/* SECTION 1 */}
                      <div class="col-md-12 nopadding">
                        <div class="col-md-6 nopadding">
                          <div class="col-md-12 step-one">
                            <div class="form-group">
                              <label class="col-md-6" for="item">
                                Buying Sample Dated
                              </label>
                              <input
                                type="date"
                                class="form-control col-md-6"
                                name="buyingSampleDated"
                                onChange={e =>
                                  this.updateValueForkeys(
                                    "sealingDetails",
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div class="col-md-12 step-one">
                            <div class="form-group">
                              <label class="col-md-6" for="item">
                                Initial Sample Dated
                              </label>
                              <input
                                type="date"
                                class="form-control col-md-6"
                                name="initialsSampleDated"
                                onChange={e =>
                                  this.updateValueForkeys(
                                    "sealingDetails",
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div class="col-md-12 step-one">
                            <div class="form-group">
                              <label class="col-md-6 active" for="item">
                                Fit Comments Expected
                              </label>
                              <input
                                type="date"
                                class="form-control col-md-6"
                                name="fitCommentExpected"
                                onChange={e =>
                                  this.updateValueForkeys(
                                    "sealingDetails",
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 nopadding">
                          <div class="col-md-12 step-one">
                            <div class="form-group">
                              <label class="col-md-6" for="item">
                                Photo Pack
                              </label>
                              <select
                                class="form-control col-md-6"
                                name="photoPack"
                                onChange={e =>
                                  this.updateValueForkeys(
                                    "sealingDetails",
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              >
                                <option>Select</option>
                                <option value="actioned">Actioned</option>
                                <option value="notactioned">
                                  Not Actioned
                                </option>
                              </select>
                            </div>
                          </div>

                          <div class="col-md-12 step-one">
                            <div class="form-group">
                              <label class="col-md-6 active" for="item">
                                Fabric for Photo Pack
                              </label>
                              <select
                                class="form-control col-md-6"
                                name="fabricForPhotoPack"
                                onChange={e =>
                                  this.updateValueForkeys(
                                    "sealingDetails",
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              >
                                <option>Select</option>
                                <option value="actioned">Actioned</option>
                                <option value="notactioned">
                                  Not Actioned
                                </option>
                              </select>
                            </div>
                          </div>

                          <div class="col-md-12 step-one">
                            <div class="form-group">
                              <label class="col-md-6 active" for="item">
                                Fabric for Photo Pack ETA
                              </label>
                              <input
                                type="date"
                                class="form-control col-md-6"
                                name="fabricForPhotoPackETA"
                                onChange={e =>
                                  this.updateValueForkeys(
                                    "sealingDetails",
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12 nopadding step-one">
                          <div class="form-group col-md-6">
                            <label class="col-md-6 active" for="item">
                              Revised Fit Submission
                            </label>
                            <input
                              type="date"
                              class="form-control col-md-6"
                              name="revisedFitSubmission"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "sealingDetails",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-12 nopadding step-one">
                          <div class="form-group col-md-6">
                            <label class="col-md-6 active" for="item">
                              Revised Fit Submission Expected
                            </label>
                            <input
                              type="date"
                              class="form-control col-md-6"
                              name="revisedFitSubmissionExpected"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "sealingDetails",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-12 nopadding step-one">
                          <div class="form-group col-md-6">
                            <label class="col-md-6 active" for="item">
                              Sealing Submission
                            </label>
                            <input
                              type="date"
                              class="form-control col-md-6"
                              name="sealingSubmission"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "sealingDetails",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-12 nopadding step-one">
                          <div class="form-group col-md-6">
                            <label class="col-md-6 active" for="item">
                              Sealing comments Expected
                            </label>
                            <input
                              type="date"
                              class="form-control col-md-6"
                              name="sealingCommentExpexted"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "sealingDetails",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-12 nopadding step-one">
                          <div class="form-group  col-md-6">
                            <label class="col-md-6 active" for="item">
                              Revised Sealing Expected
                            </label>
                            <input
                              type="date"
                              class="form-control col-md-6"
                              name="revisedSealingSubmission"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "sealingDetails",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-12 nopadding step-one">
                          <div class="form-group col-md-6">
                            <label class="col-md-6 active" for="item">
                              Revised Sealing comments Expected
                            </label>
                            <input
                              type="date"
                              class="form-control col-md-6"
                              name="revisedSealingCommentsExpected"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "sealingDetails",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-12 nopadding step-one">
                          <div class="form-group col-md-6">
                            <label class="col-md-6 active" for="item">
                              Sealing Deadline
                            </label>
                            <input
                              type="date"
                              class="form-control col-md-6"
                              name="sealingDeadline"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "sealingDetails",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>

                      {/* Additional info */}
                      <div class="col-md-12" style={{ padding: "15px 0 0" }}>
                        <div class="fabric-textarea">
                          <label for="item" class="">
                            Additional Info
                          </label>
                          <textarea
                            class="form-control"
                            rows="4"
                            cols="80"
                            name="additionalInfo"
                            onChange={e =>
                              this.updateValueForkeys(
                                "sealingDetails",
                                e.target.name,
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* SEALING END */}
                {/* ---------------------------------------------------------------------------------------------------------- */}

                {/* ---------------------------------------------------------------------------------------------------------- */}

                {/* OTHER DETAILS START */}
                <div
                  class="card-filter meeting-min-con"
                  style={{ marginBottom: "0.5%" }}
                >
                  <div class="row" style={{ padding: "1% 0 1% 0" }}>
                    <div class="col-md-12 product-form">
                      {/* TITLE OF EMBELLISHMENT */}
                      <div
                        class="col-md-12 no-padding"
                        style={{ marginBottom: "1%" }}
                      >
                        <h6 class="dev-title">
                          <b>OTHER DETAILS</b>
                        </h6>
                      </div>
                      {/* SECTION 1 */}
                      <div class="col-md-12 nopadding">
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label class="col-md-6 active" for="item">
                              Style Handover Date
                            </label>
                            <input
                              type="date"
                              class="form-control col-md-6"
                              name="styleHandoverDate"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "otherDetails",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label class="col-md-6 active" for="item">
                              Customer Selling price
                            </label>
                            <input
                              type="number"
                              class="form-control col-md-6"
                              name="customerSellingPrice"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "otherDetails",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label class="col-md-6 active" for="item">
                              Style Sold
                            </label>
                            <select
                              class="form-control col-md-6"
                              name="styleSold"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "otherDetails",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            >
                              <option>select</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label class="col-md-6 active" for="item">
                              Fusing Recommend sheet
                            </label>
                            <select
                              class="form-control col-md-6"
                              name="fusingRecommendsheet"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "otherDetails",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            >
                              <option>select</option>
                              <option value="actioned">Actioned</option>
                              <option value="notactioned">not Actioned</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label class="col-md-4 active" for="item">
                              Style Dropped
                            </label>
                            <select
                              class="form-control col-md-4"
                              name="styleDropped"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "otherDetails",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            >
                              <option>select</option>
                            </select>
                            <input
                              type="date"
                              class="form-control col-md-4"
                              name=""
                              onChange={e =>
                                this.updateValueForkeys(
                                  "otherDetails",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label class="col-md-6 active" for="item">
                              Thread recommend sheet
                            </label>
                            <select
                              class="form-control col-md-6"
                              nmae="threadRecommendSheet"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "otherDetails",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            >
                              <option>select</option>
                              <option value="actioned">Actioned</option>
                              <option value="notactioned">not Actioned</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-6 step-one">
                          <div class="form-group">
                            <label class="col-md-6 active" for="item">
                              {" "}
                              ETA Date
                            </label>
                            <input
                              type="date"
                              class="form-control col-md-6"
                              name="etaDate"
                              onChange={e =>
                                this.updateValueForkeys(
                                  "otherDetails",
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                      {/* BUTTON START */}
                      <div class="col-md-12 profile-btn text-center">
                        <button
                          type="submit"
                          name="button"
                          class="primary"
                          onClick={e => this.saveIb(e)}
                        >
                          Save
                        </button>
                        <button
                          type="button"
                          name="button"
                          class="primary ml-2"
                        >
                          {" "}
                          Confirm Order
                        </button>
                        <button
                          type="button"
                          name="button"
                          class="primary ml-2"
                        >
                          {" "}
                          Provisional Order
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* OTHER DETAILS END */}
                {/* ---------------------------------------------------------------------------------------------------------- */}
              </div>
            </div>
          </div>

          <div id="myModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-body no-padding">
                  <div class="meeting-min-con">
                    <div class="row">
                      <div class="col-md-12 no-padding">
                        <div class="col-md-8 product-form no-padding">
                          <div class="col-md-6 nopadding">
                            <div class="col-md-12 step-one">
                              <div class="form-group">
                                <label for="phone">Search Style</label>
                                <br />
                                <span>BY</span>
                                <br />
                                <select class="form-control" name="">
                                  <option value="style">Select</option>
                                  <option value="style">
                                    Meeting Notes No
                                  </option>
                                  <option value="style">Customer Name</option>
                                  <option value="style">
                                    Departement Name
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6 no-padding">
                            <div class="col-md-12 step-one ">
                              <div class="form-group">
                                <label for="ref-no" />
                                <br />
                                <span>FOR</span>
                                <br />
                                <input
                                  type="text"
                                  class="form-control"
                                  name=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4 product-form">
                          <div
                            class="col-md-12 mm-btns"
                            style={{ marginTop: "20%" }}
                          >
                            <button type="button" class="primary" name="button">
                              Search
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 no-padding">
                        <div class="table-container">
                          <table class="striped">
                            <thead>
                              <tr>
                                <th data-field="num">Meeting Notes No</th>
                                <th data-field="name">Customer Name</th>
                                <th data-field="name">Deptartment Name</th>
                                <th data-field="act">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>MN-00324</td>
                                <td>Virat</td>
                                <td>Gemma</td>
                                <td>
                                  <a href="" class="view" title="View">
                                    <i class="material-icons">visibility</i>
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="scroll-up pull-right">
            <a
              href="#top"
              class="btn-floating btn-large black"
              title="Add multiple"
            >
              <i class="fa fa-chevron-up" />
            </a>
          </div>
        </Fragment>
      )
    );
    // } else {
    //   return (
    //       <Loading />
    //   );
    // }
  }
}

export default CreateIB;



// WEBPACK FOOTER //
// ./src/pages/createIB/page.js